<template>
    <v-card class="mb-5 pt-3">
        <v-card-title>
            <v-row style="width: 100%">
                <v-col cols="7" class="d-flex flex-nowrap align-center">
                    <v-icon size="x-small" class="mr-2" color="grey-darken-1">
                        mdi-vector-polyline mdi-rotate-90
                    </v-icon>
                    <span
                        style="
                            font-size: 1.5rem;
                            font-weight: 400 !important;
                            overflow-wrap: break-word;
                            word-break: normal;
                        "
                        >{{ title }}</span
                    >
                </v-col>
                <v-col cols="5">
                    <CalcStatsChips
                        :calcId="calcId"
                        style="min-width: 0"
                        :moveToEnd="true"
                    />
                </v-col>
            </v-row>
        </v-card-title>
        <v-card-text class="pb-0">
            <div class="text-body-large font-weight-light" style="color: black">
                {{ description }}
            </div>
            <div
                class="
                    pt-2
                    text-body-large
                    font-weight-light
                    text-medium-emphasis
                "
            >
                Inputs: {{ inputText }}
            </div>
        </v-card-text>
        <v-card-actions class="pl-4">
            <span
                class="text-body-large"
                style="overflow-wrap: break-word; word-break: normal"
                v-html="folderPath"
            ></span>
            <v-spacer></v-spacer>
            <v-btn
                class="text-capitalize button text-label-medium"
                rounded
                size="small"
                variant="outlined"
                @click="switchInfoShow"
            >
                Info
                <v-icon class="icon" color="secondary">
                    mdi-information-outline
                </v-icon>
            </v-btn>
            <v-btn
                class="text-capitalize button"
                rounded
                size="small"
                variant="outlined"
                :href="calcHref"
            >
                Open
                <v-icon class="icon" color="secondary">
                    mdi-chevron-right
                </v-icon>
            </v-btn>
        </v-card-actions>
        <v-expand-transition>
            <div v-show="showInfo" class="pa-4">
                <CalcInfo :calc="calc" :libraryVersion="libraryVersion" />
            </div>
        </v-expand-transition>
    </v-card>
</template>
<script setup>
import { ref, computed } from 'vue'
import CalcStatsChips from '../calc/calc-info/CalcStatsChips.vue'
import CalcInfo from '../../shared/CalcInfo.vue'

const props = defineProps(['calc'])

const showInfo = ref(false)

function switchInfoShow() {
    showInfo.value = !showInfo.value
}

const libraryVersion = computed(() => props.calc.libraryVersion)
const title = computed(() => props.calc.name)
const calcId = computed(() => props.calc.calcId)
const description = computed(() => props.calc.description)
const inputs = computed(() => props.calc.inputs)

const folderPath = computed(() => {
    let api = props.calc.api
    let splitted = api.split('/')
    let len = splitted.length
    splitted[len - 1] = props.calc.name
    return splitted.join('<wbr>/<wbr>')
})

const inputText = computed(() => {
    if (inputs.value.length == 0) {
        return 'No inputs'
    }
    let idx = 0
    let line = ''
    for (var input of inputs.value) {
        line = line + input.name
        if (idx != inputs.value.length - 1) {
            line = line + ', '
        }
        idx = idx + 1
    }
    return line
})

const calcHref = computed(() => {
    if (props.calc.persistentCalcID)
        return `/persistentCalcs/${props.calc.persistentCalcID}`
    else return `/calcs/${props.calc.calcId}`
})
</script>
